
import { Icon } from '@ant-design/compatible';

export default Icon
